import { Container } from "aurelia-dependency-injection";
import { CategoryFilterPanelView } from "./category-filter-panel";
import { JurisdictionFilterPanelView } from "./jurisdiction-filter-panel";
import { MaterialFilterPanelView } from "./material-filter-panel";
import {backboneViewProperties} from "../../decorators/backbone-properties";
import {SearchModel} from "../models/search";
import {AppEvents} from "../../app-events";
import { ContainerHelper } from "../../shared/helpers/container-helper";

const template = require<string>("./search-filter.html");
require("../styles/search-filter.less");

const dom = {
    TOGGLE_FULLTEXT: "#fulltext-toggle",
};

@backboneViewProperties({
    template: template,
    tagName: "div",
    className: "clearfix",
    id: "filter-panel",
})

export class SearchFilterView extends Marionette.LayoutView<SearchModel> {

    private materialFilterView: MaterialFilterPanelView;
    private jurisdictionView: any;
    private categoriesView: any;
    private materialTypeRegion: Marionette.Region;
    private jurisdictionRegion: Marionette.Region;
    private categoriesRegion: Marionette.Region;
    private activeRegionSelector = "material-type-region";
    private appEvents: Backbone.Events;

    constructor(options?: any) {
        super(options);
        this.appEvents = ContainerHelper.Events;
        this.setupModelListeners();
    }

    public setupModelListeners() {
        this.listenTo(this.model, "change:ShowFulltextDocsOnly", this.updateToggleFulltextDisplay);
        this.listenTo(this.model.MaterialFacets, "change:Ticked", this.showFilteringIndicators);
        this.listenTo(this.model.CategoryFacets, "change:Ticked", this.showFilteringIndicators);
        this.listenTo(this.model.JurisdictionOverrides, "change:Ticked", this.showFilteringIndicators);
        this.appEvents.on(AppEvents.ClearFilters, () => {
            this.clearAllFiltersNoSearch();
        });
    }

    public onShow() {
        this.setupSubViews();

        this.updateToggleFulltextDisplay();
        // left Navbar
        this.$(".filter-submenu-option").removeClass("selected");
        this.$(`.filter-submenu-option[data-option="${this.activeRegionSelector}"]`).addClass("selected");

        this.showFilteringIndicators();

        // active region
        this.$(".filter-panel-region").children().removeClass("active");
        this.$("." + this.activeRegionSelector).addClass("active");

    }

    public showFilteringIndicators() {

        this.$(".filter-submenu-option").removeClass("filtering");

        if (this.model.areWeFilteringByMaterial()) {
            this.$(`.filter-submenu-option[data-option="material-type-region"]`).addClass("filtering");
        }
        if (this.model.areWeFilteringByCategory()) {
            this.$(`.filter-submenu-option[data-option="categories-region"]`).addClass("filtering");
        }
        if (this.model.areWeFilteringWithJurisdictionOverride()) {
            this.$(`.filter-submenu-option[data-option="jurisdiction-region"]`).addClass("filtering");
        }
    }

    public setupSubViews() {
        this.materialFilterView = new MaterialFilterPanelView({model: this.model});
        this.materialTypeRegion.show(this.materialFilterView);

        this.jurisdictionView = new JurisdictionFilterPanelView({model: this.model});
        this.jurisdictionRegion.show(this.jurisdictionView);

        this.categoriesView = new CategoryFilterPanelView({model: this.model});
        this.categoriesRegion.show(this.categoriesView);
    }

    public regions(): any {
        const regions: any = {
            materialTypeRegion: ".material-type-region",
            jurisdictionRegion: ".jurisdiction-region",
            categoriesRegion: ".categories-region"
        };
        return regions;
    }

    public events(): Backbone.EventsHash {
        const events: Backbone.EventsHash = {};
        events["click .filter-submenu-option"] = (e) => this.submenuOptionClicked(e);
        events["click .clear-all-filters"] = (e) => this.clearAllFilters(e);
        events["click " + dom.TOGGLE_FULLTEXT] = (e) => this.toggleFulltextClick(e);

        return events;
    }

    public clearAllFilters(e: JQueryEventObject) {
        this.model.clearAllFilters();
        _.defer(() => {
            this.model.setPage(1);
            this.model.emitSearchRequest();
        });
    }

    public submenuOptionClicked(e: JQueryEventObject) {

        // style <li>
        this.$(".filter-submenu-option").removeClass("selected");
        $(e.currentTarget).addClass("selected");

        // Select view
        const dataOpt = $(e.currentTarget).data("option");
        this.activeRegionSelector = dataOpt;

        this.$(".filter-panel-region").children().removeClass("active");
        this.$("." + dataOpt).addClass("active");
    }

    private clearAllFiltersNoSearch() {
        this.model.clearAllFilters();
    }

    private toggleFulltextClick(e: JQueryEventObject): void {
        const isActive: boolean = !this.model.ShowFulltextDocsOnly;
        this.model.ShowFulltextDocsOnly = isActive;
        this.model.setPage(1);
        this.model.emitSearchRequest();
    }

    private updateToggleFulltextDisplay() {
        $(dom.TOGGLE_FULLTEXT).prop("checked", this.model.ShowFulltextDocsOnly);
    }

}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/search/views/search-filter.ts